import { createFileRoute } from "@tanstack/react-router";
import { familiesQueryOptions } from "creso-core/hooks";
import { lazy } from "react";
import { object, z } from "zod";
import { zodValidator } from "@tanstack/zod-adapter";

const Component = lazy(() => import("@crm/pages/families"));

export const Route = createFileRoute(
  "/(auth)/_headed/clients/_layout/families"
)({
  component: Component,
  validateSearch: zodValidator(
    object({
      manage_families: z.coerce.boolean().optional(),
      assign_to_employee_id: z.coerce.number().optional(),
      filter_employee_id: z.coerce.number().optional(),
    })
  ),
  loader: async ({ context }) => {
    const { queryClient } = context;

    await queryClient
      .ensureQueryData(familiesQueryOptions({ page: 1, pageSize: 50 }))
      .catch(() => undefined);
  },
});
